<label>
  <div class="form-field__label form-field__quiz-summary-label">
    @if (fieldIsCorrect) {
      <fa-icon
        size="lg"
        [icon]="iconCorrect"
        class="form-field__quiz-summary-label__icon"
      ></fa-icon>
    }
    <div class="form-field__quiz-summary-label__label">
      {{ field?.label | translateInline }}
    </div>
  </div>

  @for (option of allOptions$ | async; track $index) {
    <div class="form-field__summary form-field__quiz-summary-option">
      <fa-icon
        size="lg"
        [icon]="option.correct ? iconCorrect : iconIncorrect"
        [class]="
          option.correct
            ? 'form-field__quiz-summary-option--correct'
            : 'form-field__quiz-summary-option--false'
        "
        class="form-field__checkbox-summary-icon"
      ></fa-icon>
      <fa-icon
        [icon]="option.checked ? iconChecked : iconUnchecked"
        size="lg"
        class="form-field__checkbox-summary-icon"
      ></fa-icon>

      {{ option.label | translateInline }}
    </div>
  }
</label>
